export default __webpack_public_path__ + "static/media/photo--lg--blitz-6.ad62fb02.jpg";